import React, { Component } from 'react'

class InitialRemoteConnectionContent extends Component {
  render() {
    return (
      <div id='remotePopoutWindowId'>
        Loading
      </div>
    )
  }
}

export default InitialRemoteConnectionContent
